import apiClient from '@/axios';

export const apiService = {
  // Collections
  getCategories(params) {
    return apiClient.get('/categories', { params });
  },

  getProducts(params) {
    return apiClient.get('/products', { params });
  },

  getFeedbacks(params) {
    return apiClient.get('/feedbacks', { params });
  },

  getJobsNeeds(params) {
    return apiClient.get('/jobs-needs', { params });
  },

  getProjects(params) {
    return apiClient.get('/projects', { params });
  },

  getPartenaires(params) {
    return apiClient.get('/partenaires', { params });
  },

  // Entities
  getProductById(id) {
    return apiClient.get(`/products/${id}`);
  },

  // Auth
  login(payload) {
    return apiClient.post('/login', payload);
  },

  register(payload) {
    return apiClient.post('/register', payload);
  },

  // Forms
  submitSubscription(payload) {
    return apiClient.post('/subscriptions', payload);
  },

  submitRecruitment(formData, config = {}) {
    return apiClient.post('/recruitments', formData, config);
  },

  submitContact(payload, config = {}) {
    return apiClient.post('/contact', payload, config);
  },

  submitFeedback(payload, config = {}) {
    return apiClient.post('/feedbacks', payload, config);
  },
};
